import { render, staticRenderFns } from "./TaxiForm.vue?vue&type=template&id=00dfd684&scoped=true&"
import script from "./TaxiForm.vue?vue&type=script&lang=js&"
export * from "./TaxiForm.vue?vue&type=script&lang=js&"
import style0 from "./TaxiForm.vue?vue&type=style&index=0&id=00dfd684&prod&lang=scss&"
import style1 from "./TaxiForm.vue?vue&type=style&index=1&id=00dfd684&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dfd684",
  null
  
)

export default component.exports